<script setup lang="ts">
    interface CaptionProps {
        caption: string | undefined;
        copyright?: string;
        fullBleed?: boolean;
        type?: 'div' | 'figcaption';
    }
    withDefaults(defineProps<CaptionProps>(), {
        type: 'div',
    });
</script>
<template>
    <component
        :is="type"
        class="atm-caption text-woom text-xs text-woom-grey-moon">
        <div :class="{ 'mx-auto max-lg:px-6 lg:max-w-layout-lg xl:max-w-layout-xl': fullBleed }">
            <em>{{ caption }}</em>
            <small v-if="copyright"> - &copy;{{ copyright }}</small>
        </div>
    </component>
</template>
